class LLHomeJourney {
  constructor(root) {
    this.root = root;
    this.tabs = [...root.querySelectorAll('[data-ll-journey-tab]')];
    this.panels = [...root.querySelectorAll('[data-ll-journey-panel]')];

    if (!this.tabs.length || this.tabs.length !== this.panels.length) return;

    this.root.classList.add('is-ready');
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      this.panels[tabIndex].classList.toggle('is-active', active);
      this.panels[tabIndex].hidden = !active;
    });

    if (focus) this.tabs[index].focus();
  }

  onKeydown(event, index) {
    let nextIndex = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

const initLLHomeJourneys = (container = document) => {
  container.querySelectorAll('[data-ll-home-journey]').forEach((root) => {
    if (root.dataset.llInitialized === 'true') return;
    root.dataset.llInitialized = 'true';
    new LLHomeJourney(root);
  });
};

document.addEventListener('DOMContentLoaded', () => initLLHomeJourneys());
document.addEventListener('shopify:section:load', (event) => {
  initLLHomeJourneys(event.target);
});
